import React from 'react';

const MyIngredientsPage = () => {
  return <div>自分が記録した食材一覧</div>;
};

export default MyIngredientsPage;
